<template>
  <div class="myheader">
    <div class="myheaderleft">
      <img
        @click="logoClick"
        :style="
          isHavebas
            ? 'width:160px;height:40px;'
            : isCustom
            ? custom == 'xugong'
              ? 'width:114px;height:26px;'
              : 'width:176px;height:26px;'
            : isSimple
            ? 'width:120px;height:44px;'
            : 'width:120px;height:40px;'
        "
        :src="logosrc"
      />
      <div></div>
      <p>{{ ptname }}</p>
    </div>
    <div class="myheaderright">
      <el-badge class="item">
        <el-tooltip
          v-if="powersObj.createAtlas"
          class="item"
          effect="dark"
          content="资源上传"
          placement="bottom"
        >
          <img
            @click="openUpload"
            style="cursor: pointer"
            src="@/assets/myheader/upload.png"
            alt
          />
        </el-tooltip>
      </el-badge>
      <el-badge
        v-if="
          powersObj.allowApply &&
          (powersObj.pictureDownload ||
            powersObj.picturePush ||
            powersObj.pictureShare)
        "
        :value="loveList.length"
        class="item"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="图片选用"
          placement="bottom"
        >
          <img
            @click="openDrawer"
            style="cursor: pointer"
            src="@/assets/myheader/file.png"
            alt
          />
        </el-tooltip>
      </el-badge>
      <el-dropdown :hide-on-click="false" @command="changeUser">
        <span class="el-dropdown-link">
          <div>
            <img src="@/assets/myheader/avatar.png" alt />
            <div style="font-size: 14px">{{ loginInfo.name }}</div>
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="powersObj.mySetting" command="a"
            >修改个人信息</el-dropdown-item
          >

          <el-dropdown-item divided command="b">注销</el-dropdown-item>

          <el-dropdown-item divided command="c">关于</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- <el-dialog title="修改个人信息" width="32%" :before-close="handleClose" :visible.sync="mydialogVisible">
      <el-form :model="myform" ref="myform" :rules="rules">
        <el-form-item label="姓名" label-width="80px" prop="name">
          <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="手机" label-width="80px" prop="phone">
          <el-input v-model="myform.phone" placeholder="请输入11位手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" label-width="80px" prop="email">
          <el-input v-model="myform.email" placeholder="必填，不超过60个字"></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="80px" prop="newpsw">
          <el-input v-model="myform.newpsw" placeholder="留空为不修改，8-16个字，请尽量复杂！"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quit">取 消</el-button>
        <el-button type="primary" @click="submit('myform')">提 交</el-button>
      </div>
    </el-dialog>-->

    <checkdialog
      :title="title"
      :text="text"
      :dialogVisible="checkDialogVisible"
      @handleClose="checkHandleClose"
      @beSure="beSure"
    ></checkdialog>

    <el-dialog
      :visible.sync="dialogVisible"
      width="32%"
      append-to-body
      :before-close="handleClose"
    >
      <div
        slot="title"
        class="header-title"
        :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom
            ? customColor
            : isSimple
            ? '#FD9112'
            : '#185ED3',
        }"
      >
        <div>修改个人信息</div>
      </div>
      <el-form :model="myform" ref="myform" :rules="rules">
        <el-form-item label="昵称" label-width="80px" prop="name">
          <el-input
            v-model="myform.name"
            placeholder="必填，2-10个字"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机" label-width="80px" prop="mobile">
          <el-input
            v-model="myform.mobile"
            placeholder="请输入11位手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" label-width="80px" prop="email">
          <el-input
            v-model="myform.email"
            placeholder="必填，不超过60个字"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="80px" prop="newpsw">
          <el-input
            v-model="myform.newpsw"
            placeholder="留空为不修改，8-16个字，请尽量复杂！"
          ></el-input>
        </el-form-item>

        <el-form-item label="解绑" v-if="myform.isbind" label-width="80px">
          <span
            @click="unbindClick"
            :style="{
              cursor: 'pointer',
              color: isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3',
            }"
            >微信解绑</span
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quit">取 消</el-button>
        <el-button
          type="primary"
          :style="{
            border: 'none',
            backgroundColor: isCustom
              ? customColor
              : isSimple
              ? '#FD9112'
              : '#185ED3',
          }"
          @click="submit('myform')"
          >提 交</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="aboutDialogVisible"
      width="32%"
      append-to-body
      :before-close="abouthandleClose"
    >
      <div
        slot="title"
        class="header-title"
        :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom
            ? customColor
            : isSimple
            ? '#FD9112'
            : '#185ED3',
        }"
      >
        <div>关于</div>
      </div>
      <div class="about">
        <p>版本号：v2.1.8</p>
        <p>更新内容：</p>
        <ul>
          <li>1. 修复新增手动标签的问题</li>

          <!-- <li>2. 新增图集中图片批量删除操作</li>
          <li>3. 新增栏目征稿批量发布操作</li> -->
          <!-- <li>3. 修复上传限制问题</li> -->
        </ul>
        <div
          class="seeMore"
          :style="{
            backgroundColor: isCustom
              ? customColor
              : isSimple
              ? '#FD9112'
              : '#185ED3',
          }"
          @click="$router.push('/versionChange')"
        >
          查看更多
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import checkdialog from "@/components/mydialog/checkdialog/checkdialog";
import { updateMy, updateUser, setOffline, unbind } from "@/api/user";
import { mapGetters, mapActions } from "vuex";
import { powersObj } from "@/constants/powers";
import { getAppBaseConfig } from "@/api/config";
export default {
  components: {
    checkdialog,
  },
  watch: {
    "$store.state.user.isUpload"(data) {
      this.isUpload = data;
    },
  },
  computed: {
    ...mapGetters(["loginInfo"]),
  },
  data() {
    return {
      //权限
      powersObj,

      logosrc: "",
      ptname: "",
      isHavebas: false,

      aboutDialogVisible: false,

      loveList: [],
      dialogVisible: false,
      title: "确认框",
      text: "确认注销吗？",
      isAside: false,
      mydialogVisible: false,
      checkDialogVisible: false,
      myform: {
        id: 60000,
        name: "",
        mobile: "",
        email: "",
        newpsw: "",
        sort: 0,
        status: 0,
        userType: 0,
        roleIds: "",
        wxbind: "",
        isbind: false,
      },
      rules: {
        name: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机", trigger: "blur" },
          { min: 11, max: 11, message: "长度在 11 个字符", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
          { min: 2, max: 60, message: "长度不超过 60 个字符", trigger: "blur" },
        ],
        newpsw: [
          {
            min: 8,
            max: 16,
            message: "长度在 8 到 16 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(["setIsUpload"]),
    ...mapActions(["setDrawer"]),
    ...mapActions(["setLoginInfo"]),
    ...mapActions(["setLoveList"]),
    logoClick() {
      this.isAside = !this.isAside;
      this.bus.$emit("changeIsaside", this.isAside);
    },
    changeUser(command) {
      if (command === "a") {
        this.dialogVisible = true;
      }
      if (command === "b") {
        this.checkDialogVisible = true;
      }
      if (command === "c") {
        this.aboutDialogVisible = true;
      }
    },
    abouthandleClose() {
      this.aboutDialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },

    quit() {
      this.dialogVisible = false;
    },
    submit(form) {
      if (this.myform.newpsw != "") {
        let pswRegex = new RegExp(
          "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}"
        );
        if (!pswRegex.test(this.myform.newpsw)) {
          // this.$message.warning('密码包含大写字母，小写字母，数字，特殊字符！')
          this.$message({
            message: "密码包含大写字母，小写字母，数字，特殊字符！",
            type: "warning",
            duration: 5000,
          });
          return;
        }
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.myform.newpsw) {
            this.myform.password = this.$md5(this.myform.newpsw);
          }
          console.log(this.myform);
          this.updateUserAsync(this.myform);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //确认框的事件
    checkHandleClose() {
      this.checkDialogVisible = false;
    },
    beSure() {
      this.checkDialogVisible = false;
      localStorage.removeItem("loginInfo");
      localStorage.removeItem("powers");
      sessionStorage.removeItem("roleCode");
      localStorage.removeItem("createUid");
      localStorage.removeItem("token");
      localStorage.removeItem("firstPage");
      sessionStorage.removeItem("picLove");
      sessionStorage.removeItem("isChangePsw");
      setTimeout(() => {
        // location.reload();
        this.$router.push("/loginNoToken");
      }, 888);
    },

    //打开图片上传
    openUpload() {
      // if(this.$route.fullPath === '/piclist'){
      //   this.setIsUpload(false)
      // }
      this.$router.push({
        path: "/pictureUpload",
      });
    },

    //打开openDrawer
    openDrawer() {
      // console.log(1)
      this.setDrawer(true);
    },
    //获取应用基础配置
    async getAppBaseConfigAsync() {
      let { status, data, message } = await getAppBaseConfig();
      if (status) {
        this.isHavebas = false;
        if (data.logo) {
          this.logosrc = data.logo
          this.isHavebas = true
        }else{
          if (this.isCustom) {
            if (this.custom == "xugong") {
              this.logosrc = require("@/assets/custom/nxg-logo.png");
            } else {
              this.logosrc = require("@/assets/custom/nwc-logo.png");
            }
          } else {
            if (this.isSimple) {
              this.logosrc = require("@/assets/simple/logo-simple.png");
            } else {
              this.logosrc = require("@/assets/login/logo.png");
            }
          }
        }

        

        // this.isHavebas = false;
        // if (data.logo) {
        //   this.logosrc = data.logo
        //   this.isHavebas = true
        // } else {
        //   if (this.isSimple) {
        //     this.logosrc = require('@/assets/simple/logo-simple.png')
        //   } else {
        //     this.logosrc = require('@/assets/login/logo.png')
        //   }

        //   this.isHavebas = false
        // }
        if (data.name) {
          this.ptname = data.name;
        } else {
          this.ptname = "南京路特软件有限公司";
        }
      }
    },
    unbindClick() {
      this.$confirm("确定解绑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loginInfo.wxbind = 0;
        this.setLoginInfo(this.loginInfo);
        this.unbindAsync();
      });
    },

    //解绑
    async unbindAsync() {
      let { status, data, message, errors } = await unbind();
      if (status) {
        this.$message.success("解绑成功！");
        this.$router.go(0);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改个人信息
    async updateUserAsync(val) {
      let { status, data, message, errors } = await updateUser(val);
      if (status) {
        this.setLoginInfo(data);
        this.dialogVisible = false;
        this.$message.success("修改成功！");
        await setOffline(data.id);
        this.beSure();
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created() {
    setInterval(() => {
      if (
        sessionStorage.getItem("picLove") &&
        sessionStorage.getItem("picLove") !== "null"
      ) {
        let picLoveString = sessionStorage.getItem("picLove");
        if (picLoveString) {
          this.loveList = JSON.parse(picLoveString);
        }
      } else {
        this.loveList = [];
      }
      // console.log(1)
    }, 2000);

    this.getAppBaseConfigAsync();

    if (this.loginInfo) {
      this.myform.id = this.loginInfo.id;
      this.myform.name = this.loginInfo.name;
      this.myform.mobile = this.loginInfo.mobile;
      this.myform.email = this.loginInfo.email;
      // this.myform.password = this.$md5(this.loginInfo.password) || this.$md5("123456")
      this.myform.status = this.loginInfo.status;
      this.myform.sort = this.loginInfo.sort;
      this.myform.userType = this.loginInfo.userType;
      this.myform.roleIds = this.loginInfo.roleIds || "1";

      if (this.myform.hasOwnProperty("wxbind")) {
        if (this.loginInfo.wxbind == 1) {
          this.myform.isbind = true;
          this.myform.wxbind = this.loginInfo.wxbind;
        }
      }
    }
  },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      document.addEventListener("keyup", function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.setIsUpload(true);
        }
      });
    });
  },
  beforeDestroy() {
    this.bus.$emit("changeIsaside", this.isAside);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./myelheader.scss";
@import "@/constants/elHeader.scss";
</style>
<style lang="scss">
.el-badge /deep/ .el-badge__content {
  height: 14px !important;
  padding: 0 5px !important;
  line-height: 14px !important;
}
</style>
